/** Number of product cards shown before a row-based interstitial on one page. */
export function getInterstitialInsertAfter(productCount: number, cardsPerRow: number, afterRow: number): number | null {
  if (productCount === 0) return null;
  return Math.min(productCount, cardsPerRow * afterRow);
}
